import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Core2Config } from '../../utils/core2-config';
import { ApiVisa } from '../../models/base/apivisa.model';
import { Pagination } from '../../models/pagination/pagination.model';
import { BaseService } from '../../templates/services/base-service.template';
import { getHttpHeader } from '../../utils/http-header.factory';
import { PagingResponseModel } from '../../models/base/paging-response.model';

@Injectable({
  providedIn: 'root'
})
export class MerchantSettlementLogService implements BaseService {

  public readonly apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pgw/summary-settlement-log';

  constructor(protected readonly http: HttpClient) {}

  public getByCriteria(p: Pagination, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<PagingResponseModel<any>>{
    return this.http.get<PagingResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }/backoffice-ep/query?${ p.toString() }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public getCreditLogByCriteria(p: Pagination, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<PagingResponseModel<any>>{
    return this.http.get<PagingResponseModel<any>>(`${ api_domain_url }${ Core2Config.TENANT_DOMAIN_URL_PREFIX }/pgw/credit-settlement-log/backoffice-ep/query?${ p.toString() }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
